<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12" class="mb-3">
          <b-button variant="primary" @click="$router.go(-1)" class="pull-left back-btn">Terug</b-button>
        </b-col>
      </b-row>
      <b-form @submit.prevent="saveItem">
        <b-row>
          <b-col cols="12">
            <b-card no-body>
              <template v-slot:header>
                <span class="pull-left mt-2 mb-2"><strong>Admin: {{item.name}}</strong></span>
                <a @click="sendInvite" class="btn btn-secondary btn-sm hoverable pull-right">Stuur uitnodiging</a>
              </template>
              <b-row>
                <b-col cols="12">
                  <b-col class="mt-4 clearfix">
                      <b-button class="pull-right" variant="primary" v-if="!editable" @click="editable = true" size="sm">Bewerken
                      </b-button>
                      <b-button type="submit" variant="success" class="float-right" size="sm" :disabled="saveButtonDisabled" v-if="editable">Wijzigingen opslaan</b-button>
                      <b-button @click.prevent="cancelEdit" class="float-right mr-3" v-if="editable" size="sm">Annuleren</b-button>
                  </b-col>
                  <hr>
                  <b-col>
                    <b-form-group label="Naam">
                      <b-form-input type="text" required v-model="item.name" :disabled="!editable"></b-form-input>
                    </b-form-group>
                    <b-form-group label="E-mailadres">
                      <b-form-input type="text" v-model="item.email" :disabled="!editable"></b-form-input>
                    </b-form-group>
                    <b-form-group label="Telefoon">
                      <b-form-input type="text" v-model="item.phonenumber" :disabled="!editable"></b-form-input>
                    </b-form-group>
                    <b-form-group label="Actief">
                      <b-form-checkbox switch value=1 unchecked-value=0 v-model="item.active" disabled></b-form-checkbox>
                    </b-form-group>
                    <b-form-group label="Aangemaakt op">
                      <b-form-input type="text" v-model="item.created_at" disabled></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </b-form>
    </div>
  </div>
</template>
<script>
import {addData, getData, updateData} from '../../api';
import ProjectParticipations from "@/views/projects/parts/Participations";
import ProjectUpdates from "@/views/projects/parts/Updates";
import ProjectKeyData from "@/views/projects/parts/KeyData";
import ProjectFases from "@/views/projects/parts/Fases";

export default {
  name: 'project',
  components: {ProjectFases, ProjectKeyData, ProjectUpdates, ProjectParticipations},
  props: ['id'],
  data() {
    return {
      saveButtonDisabled: false,
      feedback: {
        show: false,
        text: '',
        variant: null,
        dismissCountDown: 4
      },
      contacts: [],
      editable: false,
      companyOptions: [],
      countryOptions: [],
      item: [],
      errors: null,
    }
  },
  methods: {
    async getItem() {
      const item = await getData('users/' + this.$route.params.id).then(response => response.data);
      this.item = item.data
    },
    async saveItem() {
      this.errors = null;
      this.saveButtonDisabled = true;
      const request = await updateData('users/' + this.$route.params.id, {
        'name': this.item.name,
        'email': this.item.email,
        'phonenumber': this.item.phonenumber,
      });
      if (request.status === 200) {
        this.item = request.data.data;
        this.feedback.show = true;
        this.feedback.text = 'Gebruiker succesvol geupdate';
        this.feedback.variant = 'success';
        this.editable = false;
        this.saveButtonDisabled = false;
      } else {
        this.errors = request.data.errors;
        this.feedback.show = true;
        this.feedback.text = 'Er ging iets mis...';
        this.feedback.variant = 'danger';
        this.editable = true;
        this.saveButtonDisabled = false;
      }
    },
    cancelEdit() {
      this.editable = false;
      this.getItem();
    },
    countDownChanged(dismissCountDown) {
      this.feedback.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.this.feedback.dismissCountDown = this.dismissSecs
    },
    async sendInvite() {
      const request = await getData('users/'+this.$route.params.id+'/invite').then(response => response);
      if(request.data === 1) {
        alert('Uitnodiging verzonden');
      } else {
        alert('Er is iets misgegaan... Probeer het opnieuw');
      }
    }
  },
  beforeMount() {
    this.getItem();
  },
}

</script>
